<template>
  <Modal>
    <div class="modal-header">
      <slot name="header-title" />
      <h5 class="title" v-if="!$slots['header-title']">สร้างวิดีโอถ่ายทอดสด</h5>
      <button
        @click="onCloseModal"
        type="button"
        class="btn btn-close-container p-0 mr-3">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="modal-body" :class="{ 'editing-live-source': !isEditLiveData }">
      <FormGroup v-if="!isEditLiveData">
        <div class="title">
          ชื่อวิดีโอถ่ายทอดสด
          <span class="text-danger small ml-2">*ต้องระบุ</span>
        </div>
        <input class="form-control" :class="{ 'is-invalid': error.title }" @input="onInputTitle" :value="liveData.title"/>
        <div class="invalid-feedback">
          กรุณากรอกชื่อ
        </div>
      </FormGroup>
      <div v-if="isEditLiveData">
        <FormGroup>
          <div class="title">ประเภทวิดีโอถ่ายทอดสด</div>
          <SelectOption
            :value="liveData.media.type"
            :options="typeOptions"
            :removeable="false"
            :placeholder="'เลือกประเภทวิดีโอถ่ายทอดสด'"
            @onChanged="onSelectSourceType" />
        </FormGroup>
        <FormGroup :errorMessage="error.media.sourceUrl" v-if="liveData.media.type !== 'none'">
          <div class="title">ลิงก์ถ่ายทอดสด</div>
          <input
            class="form-control"
            :placeholder="'กรุณากรอกลิงก์ถ่ายทอดสด'"
            v-model="liveData.media.sourceUrl"
            :class="{ 'is-invalid': error.media.sourceUrl }" />
          <div class="invalid-feedback" v-if="error.media.sourceUrl">
            {{ error.media.sourceUrl }}
          </div>
        </FormGroup>
      </div>
    </div>
    <div class="modal-footer">
      <button
        class="btn btn-primary"
        type="button"
        :disabled="!isValid"
        @click="onSubmit">
        <slot name="button-text" />
        <span v-if="!$slots['button-text']">สร้าง</span>
      </button>
    </div>
  </Modal>
</template>

<script>
import _ from 'lodash';
import {
  parseURLToSourceKeyByType,
  isValidEmbedUrlByType,
} from '@/utils/embeddedURLManagement';
import { uploadVideo } from '@/video/api';
import SelectOption from '@/components/SelectOption.vue';
import Modal from '@/components/Modal.vue';
import FormGroup from '@/components/FormGroup.vue';

export default {
  props: {
    onEditSource: {
      type: Function,
      default: null,
    },
    live: {
      type: Object,
      default: () => {},
    },
    onClose: {
      type: Function,
      default: null,
    },
  },
  components: {
    Modal,
    FormGroup,
    SelectOption,
  },
  data() {
    return {
      defaultLiveData: {
        title: '',
        type: 'live',
        media: {
          type: 'none',
          sourceKey: '',
          sourceUrl: '',
        },
      },
      liveData: {},
      typeOptions: [
        {
          id: 'none',
          title: 'ไม่เลือกประเภทวิดีโอถ่ายทอดสด',
        },
        {
          id: 'byteark',
          title: 'Byteark',
        },
        {
          id: 'youtube',
          title: 'Youtube',
        },
        {
          id: 'facebook',
          title: 'Facebook',
        },
      ],
      error: {
        title: '',
        media: {
          sourceUrl: null,
        },
      },
    };
  },
  created() {
    const data = _.cloneDeep(this.live);
    this.liveData = _.defaults(data, this.defaultLiveData);
    if (!this.liveData.media.type) {
      this.liveData.media.type = 'none';
    }
  },
  computed: {
    isValid() {
      return this.liveData.title && this.isValidUrl;
    },
    isValidUrl() {
      const videoMedia = _.get(this.liveData, 'media', null);
      if (videoMedia) {
        const { type, sourceUrl } = videoMedia;
        if (type !== 'none' || sourceUrl) {
          return isValidEmbedUrlByType(type, sourceUrl);
        }
        return true;
      }
      return true;
    },
    isEditLiveData() {
      return !_.isEmpty(this.live);
    },
    mediaType() {
      return _.get(this.liveData, 'media.type', null);
    },
  },
  watch: {
    isValidUrl(value) {
      if (value) {
        this.error.media.sourceUrl = null;
      } else {
        this.error.media.sourceUrl = 'ลิงก์ไม่ถูกต้อง กรุณาตรวจสอบลิงก์อีกครั้ง';
      }
    },
    mediaType(newType, oldType) {
      if (oldType && newType !== oldType) {
        this.liveData.media.sourceUrl = '';
      }
    },
  },
  methods: {
    onCloseModal() {
      if (this.onClose) {
        this.onClose();
        return;
      }
      this.$router.push('/live');
    },
    async onSubmit() {
      try {
        const { type, sourceUrl } = this.liveData.media;
        this.liveData.media.sourceKey = parseURLToSourceKeyByType(type, sourceUrl);
        if (this.isEditLiveData) {
          this.onEditSource(this.liveData.media);
          return;
        }
        const response = await uploadVideo(this.liveData);
        const { id } = response.data;
        this.$router.push(`/live/${id}`);
      } catch (error) {
        this.error = error.response.data;
      }
    },
    onInputTitle(event) {
      const title = event.target.value;
      if (!title) {
        this.error.title = 'กรุณากรอกชื่อ';
        this.liveData.title = '';
      } else {
        this.error.title = '';
        this.liveData.title = title;
      }
    },
    onSelectSourceType(type) {
      this.liveData.media.type = type;
    },
  },
  beforeDestroy() {
    this.error = {
      title: '',
      media: {
        sourceUrl: null,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

.modal-body {
  min-height: 220px;
  overflow-y: visible;
}

.editing-live-source {
  min-height: 100px;
}

</style>
